import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import group_leader_crown from "../../../assets/images/group_leader_crown.png";

const CsNominateGroupleader = ({
  onNominate,
  data,
  modalVisible,
}: any) => {
  return (
    <Dialog.Root open={modalVisible}>
      <Dialog.Portal>
        {/* Background Overlay */}
        <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" />

        {/* Modal Content */}
        <Dialog.Content
          className="fixed z-50 top-1/2 left-1/2 w-[90%] max-w-md -translate-x-1/2 -translate-y-1/2 
          bg-white rounded-lg shadow-xl p-6 flex flex-col items-center"
        >
          {/* Crown Icon */}
          <div className="relative -top-10 bg-[#E9BE50] h-20 w-20 rounded-full border-4 border-white shadow-md flex items-center justify-center">
            <img src={group_leader_crown} className="w-10 h-10" />
          </div>

          {/* Message */}
          <div className="-mt-6 mb-4">
            <h2 className="text-center text-sm font-bold text-black max-w-[90%]">
              Nominate yourself as a Group Leader.
              <br />
              <span className="font-normal">Fastest Finger gets selected!</span>
            </h2>
          </div>

          {/* Nominate Button */}
          <button
            onClick={onNominate}
            className="bg-green-600 text-white text-base font-medium py-2 px-6 rounded-full shadow 
            hover:bg-green-700 transition"
          >
            Nominate Self
          </button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CsNominateGroupleader;
